const els = {
    _clsBrandList: 'brand-list',
    _clsModelList: 'model-list scroll-container',
    _clsModelListItem: 'phone-model-list',
    _attrSelectedBrand: 'selected-brand',
    _dataCustomizationData: 'customization-data',
    mainScreen: $('#main-screen'),
    wrapperSlider: $(".wrapper-slider")
};

const utils = {
    FormatStringWithUnderscore: function (str) {
        if (!str) return "";
        return str.toLowerCase().replace(/ /g, "_");
    },
    _customizationBaseURL: 'customization',
    RedirectToCustomization: function (type, brand, model, color) {
        let url = utils._customizationBaseURL + '?';
        url += !type ? '' : `type=${utils.FormatStringWithUnderscore(type)}&`;
        url += !brand ? '' : `brand=${utils.FormatStringWithUnderscore(brand)}&`;
        url += !model ? '' : `model=${utils.FormatStringWithUnderscore(model)}&`;
        url += !color ? '' : `color=${utils.FormatStringWithUnderscore(color)}&`;
        window.location = url;
    },
    SetUrlParams: function (paramKey, paramValue){
        const url = new URL(window.location);
        url.searchParams.set(paramKey, utils.FormatStringWithUnderscore(paramValue));
        window.history.pushState({}, '', url);
    }
};

const CustomizationItems = {
    jsonURL: 'https://s3.ap-south-1.amazonaws.com/myxtur2.0/Prod/Additional-Files/custom_product_navigation.json',
    CreatePopElements: function () {
        fetch(CustomizationItems.jsonURL)
            .then(response => response.json())
            .then(data => {
                CustomizationItems.CreateTitleCards(data);
            })
            .catch(error => {
                console.error(error);
            });
    },
    CreateTitleCards: function (data) {
        for (let i = 0; i < data.length; i++) {
            const currentData = data[i] || {};
            const availability = currentData["availability"] ?? true;
            if (!availability) continue;
            els.mainScreen.append(CustomizationItems._CreateTitleCard(data[i]));
        }
    },
    _CreateTitleCard: function (datum) {
        let el = document.createElement('img');
        el.src = datum.image_url;
        el.alt = utils.FormatStringWithUnderscore(datum.title);
        $(el).data(els._dataCustomizationData, datum);
        $(el).on('click', (e) => {
            CustomizationItems.OpenBrandOption(el, e);
        });
        return el;
    },
    OpenBrandOption: function (obj, ev) {

        const customizationData = $(obj).data(els._dataCustomizationData);
        const items = customizationData.items || [];

        if (!items || items.length === 0) {
            return utils.RedirectToCustomization(customizationData.title, null, null, null);
        }

        const title = customizationData.title;
        utils.SetUrlParams('type', title);

        const brandListTemplate = items
            .filter((currentItem) => currentItem?.availability ?? true)
            .map((currentItem) => {
                const altName = utils.FormatStringWithUnderscore(currentItem.title);
                return `<li>
                    <img src="${currentItem.image_url}" 
                      alt="${altName}" 
                      class="brand-option-img" 
                      onclick='CustomizationItems.OpenModelOption(${JSON.stringify(currentItem)}, "${currentItem.title}", "${title}")' />
                  </li>`;
            })
            .join('');

        const wrapperElement = `<ul class="${els._clsBrandList}">${brandListTemplate}</ul>`;
        openModelContainer(wrapperElement, 'customization-brand-list', title, true);
    },
    OpenModelOption: function (selectedItem, selectedBrand, productType) {
        const model_items = selectedItem['items'];

        if (!model_items || model_items.length === 0) {
            return utils.RedirectToCustomization(productType, selectedBrand,null, null );
        }

        utils.SetUrlParams('brand', selectedBrand);

        const modelListTemplate = model_items
            .filter(currentItem => currentItem?.availability ?? true)
            .map(currentItem => {
                const altName = utils.FormatStringWithUnderscore(currentItem.title);
                const imageUrl = currentItem["image_url"] ?? null;
                const redirectTo = `utils.RedirectToCustomization("${productType}", "${selectedBrand}", "${currentItem.title}", null)`;

                if (imageUrl) {
                    return `<li>
          <img src="${currentItem.image_url}" alt="${altName}" class="brand-option-img" onclick='${redirectTo}'>
        </li>`;
                } else {
                    return `<li class="${els._clsModelListItem}" onclick='${redirectTo}'>${currentItem.title}</li>`;
                }
            })
            .join('');

        const wrapperModelElement = `<ul class="${els._clsModelList}">${modelListTemplate}</ul>`;
        openModelContainer(wrapperModelElement, 'customization-phone-model', "Select Phone Model", true);
    }

};

$(document).ready(() => {
    CustomizationItems.CreatePopElements();
});
